import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/sales-tracker/my-trackings",
  storeLibrary: "/store-library",
  topProducts: "/sales-tracker/top-products",
};
